export default __webpack_public_path__ + "static/media/vk.156604d9.png";